import { useEffect, useState, ChangeEvent } from 'react'
import { Button, Col, FormControl, FormSelect, Row, Form } from 'react-bootstrap'
import { BuildingFillGear, FileEarmarkPersonFill, PersonVcardFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { t } from '../locale'
import {
  getAddressType,
  getAnrede,
  getFederalState,
  getLegalForms,
  getRelationshipName,
} from '../service/stammdaten'
import { ChangeEvt, CompanyForm, PersonForm } from '../types/stammdaten.type'
import { useOutsideClick } from '../hooks/useOutsideClick'
import KDayPicker from '../components/KDayPicker'

type UnthernamenProps = {
  form: CompanyForm | PersonForm
  handleChangeLocal: (e: ChangeEvt) => void
  handleDateInputChange: (e: ChangeEvent<HTMLInputElement>) => void
  history: (path: string, label: string, options?: { value: any; label: string }[]) => void
  options: any
  beziehungs: any
  handleBeziehungenTypeChange: (idx: number, value: string) => Promise<void>
  handleAddBeziehungen: () => void
  handleRemoveBeziehung?: (index: number) => void
  handleDateChange: (id: string, date: Date | null) => void
  required: any
}

export default function StammdatenBeziehungen({
  form,
  handleChangeLocal,
  handleDateInputChange,
  history,
  options,
  beziehungs,
  handleBeziehungenTypeChange,
  handleAddBeziehungen,
  handleRemoveBeziehung,
  handleDateChange,
  required,
}: UnthernamenProps) {
  const [anredeOptions, setAnredeOptions] = useState<any[]>([])
  const [legalForms, setLegalForms] = useState<any[]>([])
  const [relationshipName, setRelationshipName] = useState<any[]>([])
  const [addressType, setAddressType] = useState<any[]>([])
  const [federalState, setFederalState] = useState<any[]>([])

  const [datePickerBirthDate, setDatePickerBirthDate] = useState<number | null>(null)

  useOutsideClick(() => {
    setDatePickerBirthDate(null)
  }, 'date-picker-popup')

  useEffect(() => {
    fetchAnrede()
    fetchLegalForms()
    fetchRelationshipName()
    fetchAddressType()
    fetchFederalState()
  }, [])

  const fetchAnrede = async () => {
    try {
      const options = await getAnrede()
      setAnredeOptions(options)
    } catch (err) {
      console.error('Fetch anrede error:', err)
    }
  }

  const fetchFederalState = async () => {
    try {
      const options = await getFederalState()
      setFederalState(options)
    } catch (err) {
      console.error('Fetch anrede error:', err)
    }
  }

  const fetchLegalForms = async () => {
    try {
      const options = await getLegalForms()
      setLegalForms(options)
    } catch (err) {
      console.error('Fetch legal forms error:', err)
    }
  }

  const fetchRelationshipName = async () => {
    try {
      const options = await getRelationshipName()
      setRelationshipName(options)
    } catch (err) {
      console.error('Fetch relationship name error: ' + err)
    }
  }

  const fetchAddressType = async () => {
    try {
      const options = await getAddressType()
      setAddressType(options)
    } catch (err) {
      console.error('Fetch address type error: ', err)
    }
  }

  return (
    <div id='relationships-data' className='mb-4'>
      {form.beziehung.map((beziehung, idx) => (
        <div key={idx} className='mb-4'>
          {/* Header panela "Beziehung" */}
          <div className='bg-gray-200 p-2 p-2 d-flex align-items-center justify-content-between mb-3'>
            <span className='d-flex align-items-center'>
              <FileEarmarkPersonFill />
              &nbsp;{t('beziehung')} {beziehungs.length > 1 ? `#${idx + 1}` : ''}
            </span>
            <Link to='#' className='text-danger small' onClick={() => handleRemoveBeziehung?.(idx)}>
              {t('remove')}
            </Link>
          </div>
          <Row className='mt-2 align-items-center'>
            <Col sm={2}>
              <label className={`form-control-label required`}>{t('Hat / ist')}</label>
            </Col>

            <Col sm={4}>
              <FormSelect
                name={t('Has/is')}
                id={`beziehung.${idx}.has_is`}
                className='bg-info2'
                value={beziehung.has_is}
                onChange={handleChangeLocal}
                required={true}
              >
                <option value=''>--</option>
                <option value='hat'>{t('hat')}</option>
                <option value='ist'>{t('ist')}</option>
              </FormSelect>
            </Col>

            <Col sm='auto'>
              <button
                type='button'
                className='btn btn-link btn-sm'
                onClick={() => history(`stammdaten.beziehung.${idx}.has_is`, t('has_is'))}
              >
                <i className='fa fa-history text-dark' />
              </button>
            </Col>
          </Row>

          <Row className='mt-2 align-items-center'>
            <Col sm={2}>
              <label className={`form-control-label required`}>{t('Relationship')}</label>
            </Col>

            <Col sm={4}>
              <FormSelect
                name={t('Relationship')}
                id={`beziehung.${idx}.name`}
                className='bg-info2'
                value={beziehung.name}
                onChange={handleChangeLocal}
                required={true}
              >
                <option value=''>--</option>
                {relationshipName.map((opt, i) => (
                  <option key={i} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </FormSelect>
            </Col>

            <Col sm='auto'>
              <button
                type='button'
                className='btn btn-link btn-sm'
                onClick={() =>
                  history(`stammdaten.beziehung.${idx}.name`, t('relationship'), relationshipName)
                }
              >
                <i className='fa fa-history text-dark' />
              </button>
            </Col>
          </Row>

          <hr />

          {/* ------- Angaben zu ------- */}
          <div className='p-2 mb-3 d-flex align-items-center'>
            <BuildingFillGear /> <strong className='small'>{t('angabenZu')}</strong>
          </div>

          <Row className='mt-4'>
            <Col className='col-sm-2'>
              <label className={`form-control-label required`}>{t('adressattype')}</label>
            </Col>
            <Col>
              <div className='d-flex align-items-center gap-2'>
                <FormSelect
                  name={t('adressattype')}
                  className='bg-info2 w-25'
                  id={`beziehung.${idx}.addressee_type`}
                  value={beziehung.addressee_type || ''}
                  required={true}
                  onChange={handleChangeLocal}
                >
                  <option value=''>--</option>
                  <option key='natural_person' value='natural_person'>
                    {t('natürlichePerson')}
                  </option>
                  <option key='legal_person' value='legal_person'>
                    {t('unternehmenVereinigung')}
                  </option>
                </FormSelect>
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.beziehung.${idx}.addressee_type`, t('adressattype'), [
                      { value: 'natural_person', label: t('natürlichePerson') },
                      { value: 'legal_person', label: t('unternehmenVereinigung') },
                    ])
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </div>
            </Col>
          </Row>

          {beziehung.addressee_type === 'natural_person' && (
            <>
              <Row className='mt-4'>
                <Col className='col-sm-2'>
                  <label
                    className={`form-control-label ${required.beziehung.anrede ? 'required' : ''}`}
                  >
                    {t('anrede')}
                  </label>
                </Col>
                <Col>
                  <div className='form-group'>
                    <FormSelect
                      name={t('anrede')}
                      className='w-25 d-inline'
                      id={`beziehung.${idx}.naturliche_person_info.anrede`}
                      value={beziehung.naturliche_person_info.anrede ?? ''}
                      onChange={handleChangeLocal}
                      required={required.beziehung.anrede}
                    >
                      <option value=''>{'-- '}</option>
                      {anredeOptions.map((opt, i) => (
                        <option key={i} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </FormSelect>
                    <button
                      type='button'
                      className='btn btn-link btn-sm'
                      onClick={() =>
                        history(
                          `stammdaten.beziehung.${idx}.naturliche_person_info.anrede`,
                          t('anrede'),
                          anredeOptions
                        )
                      }
                    >
                      <i className='fa fa-history text-dark' aria-hidden='true'></i>
                    </button>
                  </div>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col className='col-sm-2'>
                  <label
                    className={`form-control-label ${required.beziehung.naturliche_person_info?.academic_degree ? 'required' : ''}`}
                  >
                    {t('titelGrad')}
                  </label>
                </Col>
                <Col>
                  <div className='form-group'>
                    <FormControl
                      name={t('titelGrad')}
                      className='w-25 d-inline'
                      type='text'
                      id={`beziehung.${idx}.naturliche_person_info.academic_degree`}
                      value={beziehung.naturliche_person_info.academic_degree || ''}
                      required={required.beziehung.naturliche_person_info?.academic_degree}
                      onChange={handleChangeLocal}
                    />
                    <button
                      type='button'
                      className='btn btn-link btn-sm'
                      onClick={() =>
                        history(
                          `stammdaten.beziehung.${idx}.naturliche_person_info.academic_degree`,
                          t('titelGrad')
                        )
                      }
                    >
                      <i className='fa fa-history text-dark' aria-hidden='true'></i>
                    </button>
                  </div>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col className='col-sm-2'>
                  <label className='form-control-label required'>{t('vorname')}</label>
                </Col>
                <Col>
                  <FormControl
                    name={t('vorname')}
                    className='w-25 d-inline'
                    type='text'
                    id={`beziehung.${idx}.naturliche_person_info.first_name`}
                    value={beziehung.naturliche_person_info.first_name || ''}
                    onChange={handleChangeLocal}
                    required={true}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.naturliche_person_info.first_name`,
                        t('vorname')
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col className='col-sm-2'>
                  <label className='form-control-label required'>{t('nachname')}</label>
                </Col>
                <Col>
                  <FormControl
                    name={t('nachname')}
                    className='w-25 d-inline'
                    type='text'
                    id={`beziehung.${idx}.naturliche_person_info.name`}
                    value={beziehung.naturliche_person_info.name || ''}
                    onChange={handleChangeLocal}
                    required={true}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.naturliche_person_info.name`,
                        t('nachname')
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col className='col-sm-2'>
                  <label
                    className={`form-control-label ${required.beziehung.naturliche_person_info?.birth_date ? 'required' : ''}`}
                  >
                    {t('geburtsdatum')}
                  </label>
                </Col>
                <Col className='col-sm-2'>
                  <Form.Control
                    id={`beziehung.${idx}.naturliche_person_info.birth_date`}
                    name={t('geburtsdatum')}
                    type='text'
                    className='form-control-sm'
                    value={beziehung.naturliche_person_info.birth_date || ''}
                    onClick={() => setDatePickerBirthDate(datePickerBirthDate === idx ? null : idx)}
                    onChange={handleDateInputChange}
                    placeholder='DD.MM.YYYY'
                    inputMode='numeric'
                    maxLength={10}
                    required={required.beziehung.naturliche_person_info?.birth_date}
                  />
                  <KDayPicker
                    open={datePickerBirthDate === idx}
                    value={beziehung.naturliche_person_info.birth_date}
                    onSelect={d => {
                      handleDateChange(`beziehung.${idx}.naturliche_person_info.birth_date`, d)
                      setDatePickerBirthDate(null)
                    }}
                  />
                </Col>
                <Col className='col-sm-2'>
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.naturliche_person_info.birth_date`,
                        t('birth_date')
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>

              <Row className='mt-3'>
                <Col className='col-sm-2'>
                  <label
                    className={`form-control-label ${required.beziehung.naturliche_person_info?.federal_state ? 'required' : ''}`}
                  >
                    {t('bundesland')}
                  </label>
                </Col>
                <Col>
                  <FormSelect
                    name={t('bundesland')}
                    className='w-25 d-inline'
                    id={`beziehung.${idx}.naturliche_person_info.federal_state`}
                    value={beziehung.naturliche_person_info.federal_state || ''}
                    onChange={handleChangeLocal}
                    required={required.beziehung.naturliche_person_info?.federal_state}
                  >
                    <option value=''>{'-- '}</option>
                    {federalState.map((opt, i) => (
                      <option key={i} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </FormSelect>
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.naturliche_person_info.federal_state`,
                        t('bundesland'),
                        federalState
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col className='col-sm-3'>
                  <label
                    className={`form-control-label ${required.beziehung.naturliche_person_info?.id_number ? 'required' : ''}`}
                  >
                    {t('idNumber')}
                  </label>
                </Col>
                <Col>
                  <FormControl
                    name={t('idNumber')}
                    className='w-25 d-inline'
                    type='text'
                    id={`beziehung.${idx}.naturliche_person_info.id_number`}
                    value={beziehung.naturliche_person_info.id_number || ''}
                    onChange={handleChangeLocal}
                    required={required.beziehung.naturliche_person_info?.id_number}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.naturliche_person_info.id_number`,
                        t('idNumber')
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
            </>
          )}

          {beziehung.addressee_type === 'legal_person' && (
            <>
              <Row className='mt-3'>
                <Col sm={2}>
                  <label
                    className={`form-control-label ${required.beziehung.anrede ? 'required' : ''}`}
                  >
                    {t('anrede')}
                  </label>
                </Col>
                <Col sm={10}>
                  <FormSelect
                    name={t('anrede')}
                    className='w-25 d-inline'
                    id={`beziehung.${idx}.legal_person_info.anrede`}
                    value={beziehung.legal_person_info.anrede ?? ''}
                    onChange={handleChangeLocal}
                    required={required.beziehung.anrede}
                  >
                    <option value=''>{'-- '}</option>
                    {anredeOptions.map((opt, i) => (
                      <option key={i} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </FormSelect>
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.legal_person_info.anrede`,
                        t('anrede'),
                        anredeOptions
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col sm={2}>
                  <label className='form-control-label required'>{t('Unternehmensname')}</label>
                </Col>
                <Col sm={10}>
                  <FormControl
                    name={t('Unternehmensname')}
                    className='w-25 d-inline'
                    type='text'
                    id={`beziehung.${idx}.legal_person_info.name`}
                    value={beziehung.legal_person_info.name || ''}
                    onChange={handleChangeLocal}
                    required={true}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.legal_person_info.name`,
                        t('Unternehmensname')
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col sm={2}>
                  <label
                    className={`form-control-label ${required.beziehung.anrede ? 'required' : ''}`}
                    htmlFor={`beziehung.${idx}.legal_person_info.legal_form`}
                  >
                    {t('Unternehmensform')}
                  </label>
                </Col>
                <Col sm={10}>
                  <FormSelect
                    name={t('Unternehmensform')}
                    className='w-25 d-inline'
                    id={`beziehung.${idx}.legal_person_info.legal_form`}
                    value={beziehung.legal_person_info?.legal_form ?? ''}
                    onChange={handleChangeLocal}
                    required={required.beziehung.legal_person_info?.legal_form}
                  >
                    <option value=''>{'-- '}</option>
                    {legalForms.map(opt => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </FormSelect>
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.legal_person_info.legal_form`,
                        t('Unternehmensform'),
                        legalForms
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
            </>
          )}

          <hr />
          <div className='p-2 mb-3 mt-3 d-flex align-items-center'>
            <PersonVcardFill className='me-2' />{' '}
            <strong className='small'>{t('kommunikationAdresseübernehmen')}</strong>
          </div>

          {/* Adressart */}
          <Row className='mt-2'>
            <Col className='col-sm-2'>
              <label className={`form-control-label required`}>{t('adressart')}</label>
            </Col>
            <Col sm={6}>
              <div className='d-flex align-items-center gap-2'>
                <FormSelect
                  name={t('adressart')}
                  className='bg-info2 w-50'
                  id={`beziehung.${idx}.address.type`}
                  value={beziehung.address.type ?? ''}
                  onChange={handleChangeLocal}
                  required={true}
                >
                  <option value=''>--</option>
                  {addressType.map((opt, i) => (
                    <option key={i} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </FormSelect>
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.beziehung.${idx}.address.type`, t('adressart'), addressType)
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </div>
            </Col>
          </Row>

          {beziehung.address.type === 'street' && (
            <Row className='mt-3'>
              <Col className='col-sm-2'>
                <label className='form-control-label required'>{t('street')}</label>
              </Col>
              <Col sm={6}>
                <div className='d-flex align-items-center gap-2'>
                  <FormControl
                    name={t('street')}
                    className='bg-info2 w-50'
                    type='text'
                    id={`beziehung.${idx}.address.street`}
                    value={beziehung.address.street || ''}
                    onChange={handleChangeLocal}
                    required={true}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(`stammdaten.beziehung.${idx}.address.street`, t('street'))
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </div>
              </Col>
            </Row>
          )}

          {beziehung.address.type === 'post_office_box' && (
            <Row className='mt-3'>
              <Col className='col-sm-2'>
                <label className='form-control-label required'>{t('postfachadresse')}</label>
              </Col>
              <Col sm={6}>
                <div className='d-flex align-items-center gap-2'>
                  <FormControl
                    name={t('postfachadresse')}
                    className='bg-info2 w-50'
                    type='text'
                    id={`beziehung.${idx}.address.post_office_box`}
                    value={beziehung.address.post_office_box || ''}
                    onChange={handleChangeLocal}
                    required={true}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(
                        `stammdaten.beziehung.${idx}.address.post_office_box`,
                        t('postfachadresse')
                      )
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </div>
              </Col>
            </Row>
          )}

          {/* POSTCODE */}
          <Row className='mt-3'>
            <Col className='col-sm-2'>
              <label className={`form-control-label required`}>{t('postcode')}</label>
            </Col>
            <Col sm={6}>
              <div className='d-flex align-items-center gap-2'>
                <FormControl
                  name={t('postcode')}
                  className='bg-info2 w-50'
                  type='text'
                  id={`beziehung.${idx}.address.zip_code`}
                  value={beziehung.address.zip_code || ''}
                  onChange={handleChangeLocal}
                  required={true}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.beziehung.${idx}.address.zip_code`, t('postcode'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </div>
            </Col>
          </Row>

          {/* Place */}
          <Row className='mt-3'>
            <Col className='col-sm-2'>
              <label className={`form-control-label required`}>{t('place')}</label>
            </Col>
            <Col sm={6}>
              <div className='d-flex align-items-center gap-2'>
                <FormControl
                  name={t('place')}
                  className='bg-info2 w-50'
                  type='text'
                  id={`beziehung.${idx}.address.city`}
                  value={beziehung.address.city || ''}
                  onChange={handleChangeLocal}
                  required={true}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() => history(`stammdaten.beziehung.${idx}.address.city`, t('place'))}
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </div>
            </Col>
          </Row>

          {/* Country */}
          <Row className='mt-3'>
            <Col className='col-sm-2'>
              <label
                className={`form-control-label ${required.beziehung.address.country ? 'required' : ''}`}
              >
                {t('country')}
              </label>
            </Col>
            <Col sm={6}>
              <div className='d-flex align-items-center gap-2'>
                <FormSelect
                  name={t('country')}
                  className='bg-info2 w-50'
                  id={`beziehung.${idx}.address.country`}
                  value={beziehung.address.country ?? ''}
                  onChange={handleChangeLocal}
                  required={required.beziehung.address.country}
                >
                  <option value=''>--</option>
                  {options.map((option: any) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </FormSelect>
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.beziehung.${idx}.address.country`, t('country'), options)
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </div>
            </Col>
          </Row>

          {/* Telephone */}
          <Row className='mt-3'>
            <Col className='col-sm-2'>
              <label
                className={`form-control-label ${required.beziehung.address.phone ? 'required' : ''}`}
              >
                {t('telephone')}
              </label>
            </Col>
            <Col sm={6}>
              <div className='d-flex align-items-center gap-2'>
                <FormControl
                  name={t('telephone')}
                  className='bg-info2 w-50'
                  type='text'
                  id={`beziehung.${idx}.address.phone`}
                  value={beziehung.address.phone || ''}
                  onChange={handleChangeLocal}
                  required={required.beziehung.address.phone}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.beziehung.${idx}.address.phone`, t('telephone'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </div>
            </Col>
          </Row>

          {/* E-mail */}
          <Row className='mt-3'>
            <Col className='col-sm-2'>
              <label
                className={`form-control-label ${required.beziehung.address.email ? 'required' : ''}`}
              >
                {t('E-mail')}
              </label>
            </Col>
            <Col sm={6}>
              <div className='d-flex align-items-center gap-2'>
                <FormControl
                  name={t('E-mail')}
                  className='bg-info2 w-50'
                  type='text'
                  id={`beziehung.${idx}.address.email`}
                  value={beziehung.address.email || ''}
                  onChange={handleChangeLocal}
                  required={required.beziehung.address.email}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() => history(`stammdaten.beziehung.${idx}.address.email`, t('E-mail'))}
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </div>
            </Col>
          </Row>
        </div>
      ))}

      <hr />

      {/* Add (+)*/}
      <Row className='mt-3'>
        <Col>
          <Button
            variant='success'
            size='sm'
            className='btn btn-light p-0 d-flex align-items-center justify-content-center'
            style={{
              width: '28px',
              height: '28px',
              border: '1px solid #ced4da',
              color: '#198754', // bootstrap green
              fontWeight: 600,
              lineHeight: 1,
            }}
            onClick={handleAddBeziehungen}
          >
            +
          </Button>
        </Col>
      </Row>
    </div>
  )
}
